<div class="main-container-finance">
  <div class="page-header">
    <div class="breadcrumb">
      <a (click)="backToDashboard()" class="crumb crumb-link">Finance Dashboard</a>
      <span class="crumb-sep">/</span>
      <span class="crumb crumb-current">Finance Details</span>
    </div>

    <div class="page-actions">
      <button
        mat-stroked-button
        class="view-projects-btn"
        type="button"
        (click)="navigateToProjects()"
      >
        View Projects
      </button>
      <button
        *ngIf="isFinanceAdmin"
        mat-stroked-button
        class="tier-rates-btn"
        type="button"
        (click)="navigateToTierRates()"
      >
        Tier Rates
      </button>
      <!--
        Import data — one-time seeding flow. Once Finance team loads the
        full data set in prod, this button (and the modal it opens) can
        be deleted entirely; no ongoing operator surface needs it.
      -->
      <button
        *ngIf="isFinanceAdmin"
        mat-stroked-button
        class="import-btn"
        type="button"
        (click)="openImportData()"
      >
        <mat-icon>cloud_upload</mat-icon>
        <span>Import data</span>
      </button>
      <button
        mat-stroked-button
        class="download-btn"
        type="button"
        (click)="comingSoon('Download')"
      >
        <mat-icon>file_download</mat-icon>
        <span>Download</span>
      </button>
    </div>
  </div>

  <mat-card class="content-card">
    <!--
      Top-of-card tab strip. Resource Rate Card surfaces decrypted amounts,
      so its button is only rendered for finance admins (the BE endpoint is
      also @PreAuthorize-gated as a second line of defense).
    -->
    <div class="finance-tabs" role="tablist">
      <button
        type="button"
        class="finance-tab"
        role="tab"
        [class.active]="selectedTab === 'info'"
        [attr.aria-selected]="selectedTab === 'info'"
        (click)="selectedTab = 'info'"
      >
        Resource Info
      </button>
      <button
        *ngIf="isFinanceAdmin"
        type="button"
        class="finance-tab"
        role="tab"
        [class.active]="selectedTab === 'rateCard'"
        [attr.aria-selected]="selectedTab === 'rateCard'"
        (click)="selectedTab = 'rateCard'"
      >
        Resource Rate Card
      </button>
    </div>

    <ng-container *ngIf="selectedTab === 'rateCard' && isFinanceAdmin">
      <app-finance-rate-card></app-finance-rate-card>
    </ng-container>

    <ng-container *ngIf="selectedTab === 'info'">
    <div class="section-header no-title">
      <div class="section-actions">
        <mat-form-field appearance="outline" class="search-field">
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            type="text"
            placeholder="Search by name, ID, email, project, leader…"
            [(ngModel)]="searchText"
            (ngModelChange)="onSearchChange()"
          />
          <button
            *ngIf="searchText"
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="clearSearch()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="inline-filter">
          <mat-label>Year</mat-label>
          <mat-select
            [(value)]="selectedYear"
            (selectionChange)="onYearChange()"
            panelClass="finance-inline-filter-panel"
          >
            <mat-option *ngFor="let y of yearOptions" [value]="y">{{ y }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="inline-filter">
          <mat-label>Projects</mat-label>
          <mat-select
            [(value)]="selectedProjectIds"
            multiple
            placeholder="All"
            panelClass="finance-inline-filter-panel finance-projects-search-panel"
            (openedChange)="onProjectsPanelOpenedChange($event)"
          >
            <mat-select-trigger>
              {{ selectedProjectIds.length ? selectedProjectIds.length + ' selected' : 'All' }}
            </mat-select-trigger>

            <!--
              In-panel search input. (click) + (keydown) stop propagation
              so mat-select's internal keyboard nav doesn't intercept
              typing; the (keydown.space) stopper specifically prevents
              mat-select from treating spacebar as option-toggle.
            -->
            <div class="select-search" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
              <mat-icon class="select-search-icon">search</mat-icon>
              <input
                type="text"
                class="select-search-input"
                placeholder="Search projects"
                [(ngModel)]="projectFilterText"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
              />
              <button
                *ngIf="projectFilterText"
                type="button"
                mat-icon-button
                class="select-search-clear"
                aria-label="Clear search"
                (click)="projectFilterText = ''; $event.stopPropagation()"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <mat-option *ngFor="let p of filteredProjectOptions" [value]="p.id">
              {{ p.projectName }}<ng-container *ngIf="p.projectIdCode"> | {{ p.projectIdCode }}</ng-container>
            </mat-option>
            <mat-option *ngIf="filteredProjectOptions.length === 0" disabled>
              {{ projectOptions.length === 0 ? 'No projects available' : 'No projects match "' + projectFilterText + '"' }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="inline-filter">
          <mat-label>LOB</mat-label>
          <mat-select
            [(value)]="selectedSupportingLobs"
            multiple
            placeholder="All"
            panelClass="finance-inline-filter-panel"
          >
            <mat-select-trigger>
              {{ selectedSupportingLobs.length ? selectedSupportingLobs.length + ' selected' : 'All' }}
            </mat-select-trigger>
            <mat-option *ngFor="let lob of supportingLobOptions" [value]="lob.code">{{ lob.label }}</mat-option>
            <mat-option *ngIf="supportingLobOptions.length === 0" disabled>No options available</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="inline-filter inline-trigger">
          <mat-label>Filter by</mat-label>
          <input
            matInput
            readonly
            [value]="activeFilterCount > 0 ? activeFilterCount + ' active' : 'All'"
            (click)="openFilterModal()"
            class="dropdown-trigger-input"
            aria-label="Open Filter by modal"
          />
          <mat-icon matSuffix>arrow_drop_down</mat-icon>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always" class="inline-filter inline-trigger">
          <mat-label>Show by</mat-label>
          <input
            matInput
            readonly
            [value]="visibleTogglableColumns.length === togglableColumnsCanonical.length
                ? 'All'
                : visibleTogglableColumns.length + ' / ' + togglableColumnsCanonical.length + ' shown'"
            (click)="openShowByModal()"
            class="dropdown-trigger-input"
            aria-label="Open Show by modal (column visibility + order)"
          />
          <mat-icon matSuffix>arrow_drop_down</mat-icon>
        </mat-form-field>

        <button
          *ngIf="activeFilterCount > 0 || searchText"
          mat-button
          class="reset-link"
          type="button"
          (click)="resetAllFilters()"
        >
          Clear all
        </button>
      </div>
    </div>

    <ng-container *ngIf="loading">
      <ngx-skeleton-loader count="8" [theme]="{ height: '44px', 'margin-bottom': '4px' }"></ngx-skeleton-loader>
    </ng-container>

    <div *ngIf="errorMessage && !loading" class="error-state">{{ errorMessage }}</div>

    <ng-container *ngIf="!loading && !errorMessage">
      <div class="table-wrap">
        <table
          mat-table
          [dataSource]="rows"
          matSort
          [matSortActive]="sortBy"
          [matSortDirection]="sortDir"
          matSortDisableClear="false"
          (matSortChange)="onSortChange($event)"
          class="resource-info-table"
        >
          <!-- ============================================================
               Sticky columns (1–5): always visible on horizontal scroll
               ============================================================ -->
          <ng-container matColumnDef="resourceName" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header="resourceName">Resource</th>
            <td mat-cell *matCellDef="let row"
                [matTooltip]="row.isContinuation ? '' : resourceTooltip(row)"
                matTooltipShowDelay="300">
              <div *ngIf="!row.isContinuation" class="name-cell">
                <a class="resource-link">{{ row.resourceName || '—' }}</a>
                <span class="emp-id">{{ row.employeeId }}{{ row.role ? ' | ' + row.role : '' }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="history" sticky>
            <th mat-header-cell *matHeaderCellDef>History</th>
            <td mat-cell *matCellDef="let row">
              <button
                *ngIf="!row.isContinuation"
                mat-icon-button
                class="row-action"
                type="button"
                [disabled]="!row.resourceId"
                matTooltip="View resource history"
                aria-label="View resource history"
                (click)="navigateToHistory(row)"
              >
                <mat-icon>history</mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="edit" sticky>
            <th mat-header-cell *matHeaderCellDef>Edit</th>
            <td mat-cell *matCellDef="let row">
              <button
                *ngIf="!row.isContinuation"
                mat-icon-button
                class="row-action"
                type="button"
                [disabled]="!row.resourceId && !row.employeeId"
                [matTooltip]="row.isNewHire ? 'Provision new hire' : 'Edit resource info'"
                aria-label="Edit resource info"
                (click)="navigateToEdit(row)"
              >
                <mat-icon>edit</mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="copyTo" sticky>
            <th mat-header-cell *matHeaderCellDef>Copy to</th>
            <td mat-cell *matCellDef="let row">
              <button
                mat-icon-button
                class="row-action"
                type="button"
                [disabled]="!row.resourceId || !row.assignmentId"
                matTooltip="Copy this assignment to another resource"
                aria-label="Copy assignment to another resource"
                (click)="openCopyModal(row)"
              >
                <mat-icon>content_copy</mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="hiringStatus" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header="hiringStatus">Hiring Status</th>
            <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="row.assignmentId; else hiringStatusNewHire">
                <span class="status-pill" [attr.data-status]="row.hiringStatus">
                  <mat-icon class="status-icon">{{ hiringStatusIcon(row.hiringStatus) }}</mat-icon>
                  {{ formatHiringStatus(row.hiringStatus) }}
                </span>
              </ng-container>
              <ng-template #hiringStatusNewHire><span class="tbd-cell">TBD</span></ng-template>
            </td>
          </ng-container>

          <!-- ============================================================
               Scrolling columns (6+)
               ============================================================ -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="reviewStatus">Status</th>
            <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="row.isNewHire; else statusAssigned">
                <span class="status-pill review-status" data-review="NEW_HIRE">
                  <mat-icon class="status-icon">person_add</mat-icon>
                  New Hire
                </span>
              </ng-container>
              <ng-template #statusAssigned>
                <span class="status-pill review-status" [attr.data-review]="row.reviewStatus">
                  <mat-icon class="status-icon">{{ reviewStatusIcon(row.reviewStatus) }}</mat-icon>
                  {{ formatReviewStatus(row.reviewStatus) }}
                </span>
              </ng-template>
            </td>
          </ng-container>

          <ng-container matColumnDef="supportingLob">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="supportingLob">Supporting LOB</th>
            <td mat-cell *matCellDef="let row">{{ row.supportingLob || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="dntIndiaLeader">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="dntIndiaLeader">D&amp;T India Leader</th>
            <td mat-cell *matCellDef="let row">{{ row.dntIndiaLeader || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="projectNameId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="projectName">Project Name &amp; ID</th>
            <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="row.projectName || row.projectIdCode; else projectTbd">
                <div class="project-cell">
                  <span class="project-name">{{ row.projectName || '—' }}</span>
                  <span class="project-id">{{ row.projectIdCode || '' }}</span>
                </div>
              </ng-container>
              <ng-template #projectTbd><span class="tbd-cell">TBD</span></ng-template>
            </td>
          </ng-container>

          <ng-container matColumnDef="allocationPct">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="allocationPct" class="num-col">Allocation</th>
            <td mat-cell *matCellDef="let row" class="num-col">{{ formatAllocation(row.allocationPct) || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="availableAllocationPct">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="availableAllocationPct" class="num-col">Available Allocation</th>
            <td mat-cell *matCellDef="let row" class="num-col">{{ formatAllocation(row.availableAllocationPct) }}</td>
          </ng-container>

          <ng-container matColumnDef="capexOpex">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="capexOpex">CAPEX/OPEX</th>
            <td mat-cell *matCellDef="let row">{{ formatCapexOpex(row.capexOpex) || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="poType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="poType">PO Type</th>
            <td mat-cell *matCellDef="let row">{{ row.poType || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="locationType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="locationType">Location Type</th>
            <td mat-cell *matCellDef="let row">{{ row.locationType || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="poiType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="poiType">POI Type</th>
            <td mat-cell *matCellDef="let row">{{ row.poiType || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="employer">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="employer">Employer</th>
            <td mat-cell *matCellDef="let row">{{ row.employer || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="billingStartDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="billingStartDate">Start Date</th>
            <td mat-cell *matCellDef="let row">{{ formatDate(row.billingStartDate) || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="billingEndDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="billingEndDate">End Date</th>
            <td mat-cell *matCellDef="let row">{{ formatDate(row.billingEndDate) || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="tierModel">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="tierModel">Tier Model</th>
            <td mat-cell *matCellDef="let row">{{ row.tierModel || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="dntCost">
            <th mat-header-cell *matHeaderCellDef class="num-col">D&amp;T Cost</th>
            <td mat-cell *matCellDef="let row" class="num-col">{{ formatCurrency(row.dntCost) || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="glBusinessUnit">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="glBusinessUnit">GL BU</th>
            <td mat-cell *matCellDef="let row">{{ row.glBusinessUnit || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="billToFu">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="billToFu">Bill to FU</th>
            <td mat-cell *matCellDef="let row">{{ row.billToFu || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="billToMo">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="billToMo">Bill to MO</th>
            <td mat-cell *matCellDef="let row">{{ row.billToMo || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="glAccount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="glAccount">GL Account</th>
            <td mat-cell *matCellDef="let row">{{ row.glAccount || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="currentMonthFte">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="currentMonthFte" class="num-col">
              {{ currentMonthLabel }}
            </th>
            <td mat-cell *matCellDef="let row" class="num-col"
                [matTooltip]="row.currentMonthFte ? row.currentMonthFte : ''">
              {{ formatMonthlyFte(row.currentMonthFte) || tbdOrDash(row) }}
            </td>
          </ng-container>

          <ng-container matColumnDef="activity">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="activity">Activity</th>
            <td mat-cell *matCellDef="let row">{{ row.activity || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="category">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="category">Category</th>
            <td mat-cell *matCellDef="let row">{{ row.category || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="email">Email ID</th>
            <td mat-cell *matCellDef="let row">{{ row.email || '—' }}</td>
          </ng-container>

          <ng-container matColumnDef="laptopIssued">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="laptopIssued">Laptop Issued</th>
            <td mat-cell *matCellDef="let row">{{ row.laptopIssued || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="vendorRateCard">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="vendorRateCard">Vendor Rate Card</th>
            <td mat-cell *matCellDef="let row">{{ row.vendorRateCard || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="rateCardMatch">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="rateCardMatch">Rate Card Match</th>
            <td mat-cell *matCellDef="let row">{{ row.rateCardMatch || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="fullHrAmount">
            <th mat-header-cell *matHeaderCellDef class="num-col">Full HR $</th>
            <td mat-cell *matCellDef="let row" class="num-col">{{ formatCurrency(row.fullHrAmount) || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="yearTotal">
            <th mat-header-cell *matHeaderCellDef class="num-col">
              Total {{ shortYear }} $
            </th>
            <td mat-cell *matCellDef="let row" class="num-col">{{ formatCurrency(row.yearTotal) || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="city">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="city">City</th>
            <td mat-cell *matCellDef="let row">{{ row.city || '—' }}</td>
          </ng-container>

          <ng-container matColumnDef="businessSegment">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="businessSegment">Business SEG</th>
            <td mat-cell *matCellDef="let row">{{ row.businessSegment || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="productSuite">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="productSuite">Product Suite</th>
            <td mat-cell *matCellDef="let row">{{ row.productSuite || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="agileTeam">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="agileTeam">Agile Team</th>
            <td mat-cell *matCellDef="let row">{{ row.agileTeam || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="reportingManager">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="reportingManager">RM</th>
            <td mat-cell *matCellDef="let row">{{ row.reportingManager || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="l4Manager">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="l4Manager">L4 MGR</th>
            <td mat-cell *matCellDef="let row">{{ row.l4Manager || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="functionalManager">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="functionalManager">Functional MGR</th>
            <td mat-cell *matCellDef="let row">{{ row.functionalManager || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="vp">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="vp">VP</th>
            <td mat-cell *matCellDef="let row">{{ row.vp || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="svp">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="svp">SVP</th>
            <td mat-cell *matCellDef="let row">{{ row.svp || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="invoiceApprover">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="invoiceApprover">D&amp;T Invoice Approver</th>
            <td mat-cell *matCellDef="let row">{{ row.invoiceApprover || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="invoiceLocation">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="invoiceLocation">Invoice Location</th>
            <td mat-cell *matCellDef="let row">{{ row.invoiceLocation || tbdOrDash(row) }}</td>
          </ng-container>

          <ng-container matColumnDef="doj">
            <th mat-header-cell *matHeaderCellDef mat-sort-header="doj">DOJ</th>
            <td mat-cell *matCellDef="let row">{{ formatDate(row.doj) || tbdOrDash(row) }}</td>
          </ng-container>

          <!--
            Thin inline toggle column. Sits just before the months section;
            header carries a chevron icon that expands/collapses the past
            months (Jan..pivot-1). Body cells stay empty — the column is
            present purely for the header affordance. Hidden via
            displayedColumns when there are no past months to expand into
            (e.g. viewing a future year).
          -->
          <ng-container matColumnDef="monthToggle">
            <th mat-header-cell *matHeaderCellDef class="month-toggle-col">
              <button
                mat-icon-button
                type="button"
                (click)="toggleShowPastMonths()"
                [attr.aria-label]="showPastMonths ? 'Hide past months' : 'Show past months'"
                [matTooltip]="showPastMonths ? 'Hide past months' : 'Show past months'"
              >
                <mat-icon>{{ showPastMonths ? 'chevron_right' : 'chevron_left' }}</mat-icon>
              </button>
            </th>
            <td mat-cell *matCellDef="let _" class="month-toggle-col"></td>
          </ng-container>

          <!--
            Per-month columns appended after the canonical columns. matColumnDef
            id format is monthCell_<monthIndex>_<metricKey>; the displayedColumns
            getter on the component emits these in the same order so the column
            count + headers stay in sync.
          -->
          <ng-container *ngFor="let mi of visibleMonthIndices">
            <ng-container *ngFor="let metric of monthMetrics">
              <ng-container [matColumnDef]="'monthCell_' + mi + '_' + metric.key">
                <th mat-header-cell *matHeaderCellDef class="month-col">
                  {{ monthLabels[mi] }} {{ shortYear }} {{ metric.label }}
                </th>
                <td mat-cell *matCellDef="let row" class="month-col">
                  {{ formatMonthCell(row.months && row.months[mi] ? row.months[mi][metric.key] : null, metric.key) }}
                </td>
              </ng-container>
            </ng-container>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

          <tr class="empty-row" *matNoDataRow>
            <td [attr.colspan]="displayedColumns.length">
              <div class="empty-state">
                <mat-icon class="empty-icon">search_off</mat-icon>
                <h3 class="empty-title">No resources match your filters</h3>
                <p class="empty-hint">
                  Try clearing the search box or
                  <a *ngIf="activeFilterCount > 0 || searchText" (click)="resetAllFilters()" class="empty-action">resetting all filters</a>
                  <span *ngIf="!activeFilterCount && !searchText">running the Import data flow to seed the table</span>.
                </p>
              </div>
            </td>
          </tr>
        </table>
      </div>

      <mat-paginator
        class="resource-info-paginator"
        [length]="totalElements"
        [pageSize]="size"
        [pageIndex]="page"
        [pageSizeOptions]="pageSizeOptions"
        [showFirstLastButtons]="true"
        (page)="onPageEvent($event)"
        aria-label="Resource Info pagination"
      ></mat-paginator>
    </ng-container>
    </ng-container>
  </mat-card>
</div>
